import { supabase } from "@/integrations/supabase/client";

export type BackgroundRemovalMode = "standard" | "advanced";

export async function removeBackgroundViaApi(
  file: File,
  mode: BackgroundRemovalMode = "standard",
): Promise<Blob> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error("Not authenticated");

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;

  const formData = new FormData();
  formData.append("action", "remove-background");
  formData.append("mode", mode);
  formData.append("image", file);

  const res = await fetch(`${supabaseUrl}/functions/v1/image-handler`, {
    method: "POST",
    headers: { Authorization: `Bearer ${session.access_token}` },
    body: formData,
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Background removal failed (${res.status})`);
  }

  return res.blob();
}
